import { render, staticRenderFns } from "./Week.vue?vue&type=template&id=40bb2b19&scoped=true&"
import script from "./Week.vue?vue&type=script&lang=js&"
export * from "./Week.vue?vue&type=script&lang=js&"
import style0 from "./Week.vue?vue&type=style&index=0&id=40bb2b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb2b19",
  null
  
)

export default component.exports